export class Hook {
  AFFILIATION_CREATED: string;
  AFFILIATION_PAID_IN: string;
  AFFILIATION_PAID_OUT: string;
  AFFILIATION_VALIDATED: string;
  CONSUMER_REWARD_CANCELLED: string;
  CONSUMER_REWARD_PAID: string;
  CONSUMER_REWARD_POOLED: string;
  CONSUMER_REWARD_VALIDATION: string;
  NEW_OFFER: string;
  OFFER_RATE_INCREASE: string;
  OFFER_SOON_ENDING: string;
  PAYOUT_ERROR: string;
  PAYOUT_SUCCESS: string;
  REWARD_CANCELLED: string;
  REWARD_CREATED: string;
  REWARD_PAID_IN: string;
  REWARD_PAID_OUT: string;
  REWARD_VALIDATED: string;
  SCRAPPING_ERROR: string;
  REWARD_PAID: string;
  AFFILIATION_POOLED: string;
  AFFILIATION_CANCELLED: string;
  VENTILATION_FILE_AVAILABLE: string;
  NEW_OFFER_AVAILABLE: string;
  OFFER_ENDING_SOON_DATE: string;
  OFFER_ENDING_SOON_BUDGET: string;
  OFFER_CASHBACK_RATE_INCREASE: string;

  // AFFILIATION_CREATED: string;
  // AFFILIATION_PAID_IN: string;
  // AFFILIATION_PAID_OUT: string;
  // AFFILIATION_VALIDATED: string;
  // CONSUMER_REWARD_CANCELLED: string;
  // CONSUMER_REWARD_PAID: string;
  // CONSUMER_REWARD_POOLED: string;
  // CONSUMER_REWARD_VALIDATION: string;
  // NEW_OFFER: string;
  // OFFER_RATE_INCREASE: string;
  // OFFER_SOON_ENDING: string;
  // PAYOUT_ERROR: string;
  // PAYOUT_SUCCESS: string;
  // REWARD_CANCELLED: string;
  // REWARD_CREATED: string;
  // REWARD_PAID_IN: string;
  // REWARD_PAID_OUT: string;
  // REWARD_VALIDATED: string;
  // SCRAPPING_ERROR: string;
  // VENTILATION_FILE_AVAILABLE: string;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}
